import { useTranslation } from 'react-i18next';
import cls from './game-page-active-indicator.module.scss';

export type GamePageActiveIndicatorProps = {
	active: boolean;
};

export const GamePageActiveIndicator = ({ active }: GamePageActiveIndicatorProps) => {
	const { t } = useTranslation();

	return (
		<div
			className={cls.gamePageActiveIndicator}
			data-active={active || undefined}
		>
			<span className={cls.gamePageActiveIndicatorIndicator} />
			<span className={cls.gamePageActiveIndicatorLabel}>
				{active ? t('game-page.active') : t('game-page.not-active')}
			</span>
		</div>
	);
};
